<template>
  <div class="newsDetail">
    <div class="newsContent">
      <h2>{{$t('header[1].title')}}</h2>
      <div class="newsDetail-article" id="imageWrapper" ref="imageWrapper">
        <router-link to="/news" class="newsDetail-article-return">
          <em class="iconfont">&#xe7b0;</em>
          {{$t('back')}}
        </router-link>
        <div
          class="newsDetail-article-topbg"
          :style="[{'background-image': 'url('+ url + item.imageCoverName +')'},{'background-position': item.alignType == 't' ? 'top' : item.alignType == 'b' ? 'bottom' : 'center'}]"
        ></div>
        <img
          class="imgShow"
          width="100%"
          v-lazy="`${url}${item.imageCoverName}`"
          :data-url="`${url}${item.imageCoverName}`"
          ref="selfReport"
        >
        <div class="newsDetail-article-box">
          <h3>{{zLocale == 'en' ? item.titleEn == '' || item.titleEn == null ? item.title : item.titleEn : item.title}}</h3>
          <span>
            {{item.publishTime | dateFormat('MM / DD / YYYY')}}
            <em
              class="iconfont"
              @click="onDetailCanvas()"
            ></em>
            <em class="iconfont" @click="onShareLink()"></em>
          </span>
          <div
            class="content"
            v-html="zLocale == 'en' ? item.contentEn == '' || item.contentEn == null ? item.content : item.contentEn : item.content"
          ></div>
          <!-- <div class="newsDetail-article-box-tool">
            <div class="newsDetail-article-box-tool-label">
              <h4>相關標籤</h4>
              <ul>
                <li>港澳地區</li>
                <li>Audi</li>
                <li>A5</li>
                <li>旗艦陳列室</li>
                <li>quattro</li>
              </ul>
            </div>
            <div class="newsDetail-article-box-tool-share">
              <h4>立即分享</h4>
              <ol>
                <li class="iconfont">&#xe602;</li>
                <li class="iconfont">&#xe63d;</li>
                <li class="iconfont">&#xe6c1;</li>
                <li class="iconfont">&#xe7af;</li>
              </ol>
            </div>
          </div>-->
        </div>
      </div>
    </div>
    <h2>{{$t('news.moreNews')}}</h2>
    <div class="newsDetail-article newsDetail-dis">
      <router-link
        :to="'/news/detail/'+item.id "
        class="newsDetail-article-newsLi"
        v-for="item in list"
        :key="item.id"
        @click.native="handleRouter(item.id)"
      >
        <div class="newsDetail-article-newsLi-img">
          <img v-lazy="url + item.imageCoverName" :data-url="url + item.imageCoverName">
        </div>
        <div class="newsDetail-article-newsLi-text">
          <span>{{item.publishTime | dateFormat('MM / DD / YYYY')}}</span>
          <h4>{{zLocale == 'en' ? item.titleEn == '' || item.titleEn == null ? item.title : item.titleEn : item.title}}</h4>
        </div>
      </router-link>
    </div>
    <div class="newsDetail-page">
      <pager :total-page="totalPage" :init-page="currentPage" :showJump="false" @go-page="goPage"></pager>
    </div>
    <van-popup v-model="showShareLink" class="popup-share-link" closeable get-container="#app">
      <div class="popup-share-link-box">
        <span class="iconfont">&#xe601; 分享連結</span>
        <input
          ref="input_href"
          type="text"
          @focus="selectValue($event)"
          v-model="shareHref"
          readonly
        >
        <div class="button">
          <button
            type="button"
            id="copy_text"
            :data-clipboard-text="shareHref"
            @click="copy"
            class="morea-btn"
          >複製</button>
        </div>
      </div>
    </van-popup>
    <div class="canvasLoading" v-if="showDetailCanvas && canvasImageUrl == ''">
      <van-loading color="#ffffff" size="100px" text-size="24px" vertical>生成海报中...</van-loading>
    </div>
    <van-popup
      v-model="showDetailCanvas"
      class="canvasImg"
      :overlay="true"
    >
      <DetailContent :item="item" @canvasImageFun="canvasImageFun" @onDetailCanvasFun="onDetailCanvas"/>
      <!-- <div>
        <img :src="canvasImageUrl"></img>
      </div>-->
    </van-popup>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import {
  reqGetArticleDetail,
  reqGetArticleList,
  reqGetReadCountUpdate,
} from '../../utils/api'
import pager from '@/components/VuePager'
import DetailContent from '@/pages/news/DetailContent'

import NativeShare from 'nativeshare'
import Clipboard from 'clipboard'
import {
  Toast,
  Button,
  Popup,
  Overlay,
  Lazyload,
  ImagePreview,
  createApp,
  Loading,
} from 'vant'

import html2canvas from 'html2canvas' //把html生成图片
import QRCode from 'qrcodejs2' //生成二维码图片

export default {
  name: 'NewsDetail',
  components: {
    pager,
    DetailContent,
  },
  inject: ['reload'],
  data() {
    return {
      url: this.$store.state.baseURL + '/',
      showDetailCanvas: false,
      showShareLink: false,
      loadingDetailCanvas: false,
      shareHref: window.location.href,
      currentPage: 1,
      pageSize: 3,
      totalPage: 0,
      item: {},
      list: [],
      scrollTop: '',

      imgList: [],

      canvasImageUrl: '', // 临时生成图片
    }
  },
  computed: {
    ...mapState({
      zLocale: (state) => state.locale,
    }),
  },
  mounted() {
    window.addEventListener('scroll', this.showbtn, true)

    let id = this.$route.params && this.$route.params.id
    this.getArticleDetail(id)
    let data = {
      currentPage: this.currentPage,
      pageSize: this.pageSize,
      home: true, // true只查发布文章
    }
    this.getArticleList(data)
    this.$_isFixed(false)
  },
  methods: {
    ...mapMutations(['$_isFixed']),
    canvasImageFun(e) {
      this.canvasImageUrl = e
    },
    // imageChange(e) {
    //   // console.log('eeee', e.target.getAttribute('src'))
    //   // 调用
    //   this.imgList.forEach((val, i) => {
    //     console.log('vavalvalvall', val)
    //     if (e.target.getAttribute('src') === val) {
    //       // e.target.setAttribute("data-img", 1)
    //       ImagePreview({
    //         images: this.imgList,
    //         closeable: true,
    //         startPosition: i
    //       })
    //     }
    //   })
    // },

    /** 将html元素转换成海报图片 */
    // createPoster() {
    //   const name = `商城二维码${this.organization_group_name}`
    //   const posterHtml = this.$refs.postHtml
    //   // 生成海报
    //   console.log('生成海报', posterHtml, name)
    //   const domObj = posterHtml
    //   console.log(domObj)
    //   html2canvas(domObj, {
    //     allowTaint: true,
    //     useCORS: true,
    //     width: 200,
    //     height: 200,
    //     scrollY: -18,
    //     scrollX: -0,
    //     onclone(doc) {},
    //   }).then((canvas) => {
    //     // document.body.appendChild(canvas)
    //     console.log('结果', domObj, canvas)
    //     this.downloadQRImg(canvas, name)
    //   })
    // },
    /** 根据URL下载图片 */
    // downloadQRImg(canvas, name) {
    //   /** 新Image对象，可以理解为DOM */
    //   let image = new Image()
    //   /** 解决跨域 Canvas 污染问题 */
    //   image.setAttribute('crossOrigin', 'anonymous')
    //   // image.onload = function() {
    //   /** canvas.toDataURL 返回的是一串Base64编码的URL,指定格式 PNG */
    //   let imgUrl = canvas.toDataURL('image/png')
    //   console.log(imgUrl)
    //   image.src = imgUrl
    //   /** 生成一个a元素,并创建一个单击事件 */
    //   let a = document.createElement('a')
    //   a.download = name || 'photo' // 设置图片名称
    //   a.href = imgUrl // 将生成的URL设置为a.href属性
    //   a.setAttribute('id', 'myLink')
    //   document.body.appendChild(a)
    //   console.log('链接', a)
    //   this.exportCodeConfirm()
    //   // }
    // },
    /** 导出/下载 二维码 */
    // exportCodeConfirm() {
    //   setTimeout(() => {
    //     let event = new MouseEvent('click')
    //     /** 触发a的单击事件 */
    //     document.getElementById('myLink').dispatchEvent(event)
    //   }, 0)
    // },

    // productionImage() {
    //   this.loadingDetailCanvas = true
    //   // 手动创建一个 canvas 标签
    //   const canvas = document.createElement('canvas')
    //   // 获取父标签，意思是这个标签内的 DOM 元素生成图片
    //   let canvasBox = this.$refs.imageWrapper
    //   // 获取父级的宽高
    //   // const width = parseInt(window.getComputedStyle(canvasBox).width)
    //   const width = 460
    //   const height = parseInt(window.getComputedStyle(canvasBox).height)

    //   // 宽高 * 2 并放大 2 倍 是为了防止图片模糊
    //   canvas.width = width
    //   canvas.height = height
    //   canvas.style.width = width + 'px'
    //   canvas.style.height = height + 'px'

    //   const context = canvas.getContext('2d')
    //   context.scale(1, 1)

    //   const options = {
    //     backgroundColor: null,
    //     canvas: canvas,
    //     useCORS: true,
    //   }
    //   setTimeout(() => {
    //     html2canvas(canvasBox, options).then((canvas) => {
    //       // toDataURL 图片格式转成 base64
    //       console.log('canvas', canvas)
    //       let dataURL = canvas.toDataURL('image/png')
    //       this.canvasImageUrl = dataURL
    //       console.log('dataURL', dataURL)
    //       this.showDetailCanvas = true
    //       this.loadingDetailCanvas = false
    //       // this.downloadImage(dataURL)
    //     })
    //   }, 300)
    // },

    // downloadImage(url) {
    //   // 创建一个 img 标签，把图片插入到 DOM 中
    //   // 这里使用 img 是因为在客户端中，不能直接下载，要调用原生的方法
    //   const parents = this.$refs.selfReport
    //   const createImg = document.createElement('img')
    //   const insertEle = this.$refs.insetElement
    //   parents.insertBefore(createImg, parents.childNodes[0])

    //   createImg.setAttribute('src', url)

    //   // 如果是在网页中可以直接创建一个 a 标签直接下载
    //   let a = document.createElement('a')
    //   a.href = url
    //   a.download = '文件名'
    //   a.click()
    // },

    onShareLink() {
      this.showShareLink = true
      this.$nextTick(() => {
        this.$refs.input_href.focus()
      })
    },
    onDetailCanvas() {
      this.showDetailCanvas = !this.showDetailCanvas
    },

    // 点击选中所有
    selectValue(e) {
      e.currentTarget.select()
    },
    copy() {
      var _this = this
      var clipboard = new Clipboard('#copy_text')

      clipboard.on('success', (e) => {
        Toast('複製成功')
        // 释放内存
        clipboard.destroy()
        this.$nextTick(() => {
          this.$refs.input_href.focus()
        })
      })
      clipboard.on('error', (e) => {
        // 不支持复制
        Message({
          message: '該瀏覽器不支持自動複製',
          type: 'warning',
        })
        // 释放内存
        clipboard.destroy()
      })
    },
    onSelect() {
      const self = this

      // var nativeShare = new NativeShare({
      //   // wechatConfig: {
      //   //   appId: self.shlist.appId,
      //   //   timestamp: self.shlist.timestamp,
      //   //   nonceStr: self.shlist.nonceStr,
      //   //   signature: self.shlist.signature,
      //   // },
      //   // 让你修改的分享的文案同步到标签里，比如title文案会同步到<title>标签中
      //   // 这样可以让一些不支持分享的浏览器也能修改部分文案，默认都不会同步
      //   syncDescToTag: false,
      //   syncIconToTag: false,
      //   syncTitleToTag: false,
      // })

      var nativeShare = new NativeShare()
      // 设置分享文案
      nativeShare.setShareData({
        // icon: require('../../img/klm_cn.png'),
        // link: window.location.href,
        title: '锦龙汽车集团',
        // desc: self.title,
        from: '@fa-ge',
      })

      // 唤起浏览器原生分享组件(如果在微信中不会唤起，此时call方法只会设置文案。类似setShareData)
      try {
        nativeShare.call()
        // 如果是分享到微信则需要 nativeShare.call('wechatFriend')
        // 类似的命令下面有介绍
        // console.log('支持')
      } catch (err) {
        // 如果不支持，你可以在这里做降级处理
        self.$toast('不支持该浏览器自动分享,请您手动分享')
      }
      // this.showShare = false;
    },
    // 显示回到顶部按钮
    showbtn() {
      let that = this
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      that.scrollTop = scrollTop
    },

    //回到顶部功能实现过程
    backtop() {
      var timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop
        let ispeed = Math.floor(-osTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed
        this.isTop = true
        if (osTop === 0) {
          clearInterval(timer)
        }
      }, 20)
    },

    handleRouter(id) {
      this.getArticleDetail(id)
      this.backtop()
    },

    async getArticleDetail(id) {
      let data = id * 1
      let res = await reqGetArticleDetail(data)

      // this.$nextTick(()=>{
      let imgRe = /<img [^>]*src=['"]([^'"]+)[^>]*>/gi
      this.item = res.data.data

      let imgUrls = this.item.content.match(imgRe)

      if (imgUrls == null) return false
      let arrImg = []
      for (let i = 0; i < imgUrls.length; i++) {
        imgUrls[i].replace(imgRe, (match, capture) => {
          // console.log('match', capture.slice(0, 10))
          if (capture.slice(0, 10) != 'data:image') {
            arrImg.push(capture)
            let reg = new RegExp(`src="${capture}"`, 'g')
            this.item.content = this.item.content.replace(
              reg,
              `src="${capture}" preview="${1}" v-lazy="${capture}" data-url="${capture}"`
            )
            this.item.contentEn = this.item.contentEn.replace(
              reg,
              `src="${capture}" preview="${1}" v-lazy="${capture}" data-url="${capture}"`
            )
          }
        })
      }
      // console.log(arrImg)
      this.imgList = arrImg
      this.$previewRefresh()
      // })

      let resCount = await reqGetReadCountUpdate({ id: data })
    },
    async getArticleList(data) {
      let res = await reqGetArticleList(data)
      this.list = res.data.data.list
      this.totalPage = res.data.data.pages
    },

    goPage(e) {
      this.currentPage = e.page
      let data = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        home: true, // true只查发布文章
      }
      this.getArticleList(data)
    },
  },
  watch: {
    '$route.params.id': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) this.$_isFixed(false)
      },
    },
    // '$store.state.locale': {
    //   handler (newVal, oldVal) {
    //     if (newVal != oldVal) {
    //       this.reload()
    //     }
    //   },
    //   deep: true
    // }
  },
}
</script>

<style lang="scss" scoped>
@import '../../../static/stylebody.css';
.imgShow {
  width: 100%;
  display: none;
}
.canvasImg {
  overflow-y: scroll;
  width: 460px;
  height: auto;
}
.canvasImg::-webkit-scrollbar {
  width: 0px;
}
.canvasImg::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
}
.canvasImg::-webkit-scrollbar-track {
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.canvasLoading {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.popup-share-link {
  width: 400px;
  height: 300px;
  &-box {
    padding: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
    font-size: 16px;
    span {
      display: inline-block;
      width: 100%;
      margin-bottom: 30px;
    }
    input {
      padding: 0 8px;
      display: inline-block;
      width: 100%;
      height: 34px;
      margin-bottom: 30px;
    }
    .button {
      display: inline-block;
      width: 100%;
      text-align: right;
      button {
        width: 98px;
        height: 36px;
        background: #cb1c39;
        color: #fff;
      }
    }
  }
}

.newsDetail {
  margin-top: 142px;
  &-article {
    position: relative;
    padding: 32px 0;
    margin-bottom: 100px;
    // display: flex;
    // flex-direction: column;
    border-top: $border-top-1;
    &-topbg {
      width: 100%;
      height: 550px;
      background-size: cover;
    }
    &-return {
      // position: absolute;
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      width: 100%;
      font-size: 16px;
      color: $color-grey-1;
      em {
        margin-right: 10px;
        font-size: 16px;
      }
    }
    &-box {
      margin-top: 18px;
      // padding-left: 34%;
      display: inline-block;
      width: 100%;
      h3 {
        margin-bottom: 30px;
        font-size: 34px;
      }
      span {
        margin-bottom: 30px;
        position: relative;
        display: block;
        font-size: 16px;
        color: $color-grey-2;
        em {
          display: block;
          cursor: pointer;
          &:nth-of-type(1) {
            &::after {
              right: 50px;
            }
          }

          &::after {
            content: '\e6d1';
            position: absolute;
            top: 0;
            right: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            font-size: 22px;
            background: $color-2;
            color: $color-fff;
          }
          &:nth-of-type(1) {
            &::after{
              content: '\e611';
            }
          }
        }
      }
      .content {
        // padding-bottom: 120px;
        // border-bottom: $border-bottom-1;
        width: 100%;
        /deep/ img {
          // width: 100%;
          cursor: pointer;
        }
      }
      &-tool {
        padding: 40px 0;
        border-bottom: $border-bottom-1;
        h4 {
          font-size: 20px;
          margin-bottom: 24px;
        }
        ul {
          margin-bottom: 24px;
          display: flex;
          li {
            margin-right: 24px;
            font-size: 16px;
            text-align: center;
            width: 144px;
            height: 42px;
            line-height: 42px;
            border: $border-1;
          }
        }
        ol {
          display: flex;
          li {
            margin-right: 52px;
            font-size: 33px;
          }
        }
        &-share {
          margin-top: 50px;
        }
      }
    }
    &-newsLi {
      margin-right: 20px;
      width: calc(33.33% - 10px);
      display: flex;
      align-items: center;
      color: #333;
      cursor: pointer;
      &:nth-of-type(3n) {
        margin-right: 0;
      }
      &-img {
        // width: 180px;
        width: 34%;
        img {
          width: 100%;
        }
      }
      &-text {
        width: 66%;
        margin-left: 10px;
        h4 {
          font-size: 18px;
          line-height: 24px;
        }
        span {
          display: block;
          font-size: 16px;
          margin-bottom: 10px;
        }
      }
    }
  }
  &-dis {
    padding: 34px 0 !important;
    margin-bottom: 0;
    display: flex;
  }
  &-page {
    margin-bottom: 120px;
  }
}

@media (max-width: 1600px) {
  .newsDetail {
    &-article {
      padding: 32px 0;
      &-return {
        font-size: 16px;
        em {
          margin-right: 12px;
          font-size: 16px;
        }
      }
      &-box {
        span {
          em {
            &::after {
              width: 42px;
              height: 42px;
              font-size: 25px;
            }
          }
        }
        &-tool {
          padding: 36px 0;
          ul {
            margin-bottom: 24px;
            li {
              margin-right: 20px;
              font-size: 16.5px;
              text-align: center;
              width: 124px;
              height: 34px;
              line-height: 34px;
              border: $border-1;
            }
          }
          ol {
            li {
              margin-right: 42px;
              font-size: 27px;
            }
          }
          &-share {
            margin-top: 46px;
          }
        }
      }
      &-newsLi {
        &-text {
          margin-left: 16px;
          span {
            font-size: 15px;
            margin-bottom: 8px;
          }
        }
      }
    }
    &-page {
      margin-bottom: 104px;
    }
  }
}
@media (max-width: 1440px) {
  .newsDetail {
    &-article {
      padding: 32px 0;
      &-box {
        span {
          em {
            &::after {
              width: 39px;
              height: 39px;
              font-size: 23px;
            }
          }
        }
        &-tool {
          h4 {
            font-size: 19px;
            margin-bottom: 17px;
          }
          ul {
            margin-bottom: 24px;
            li {
              margin-right: 16px;
              font-size: 15px;
              text-align: center;
              width: 124px;
              height: 34px;
              line-height: 34px;
              border: $border-1;
            }
          }
          &-share {
            margin-top: 42px;
          }
        }
      }
      &-newsLi {
        &-text {
          h4 {
            font-size: 16px;
            line-height: 22px;
          }
          span {
            font-size: 14px;
            margin-bottom: 5px;
          }
        }
      }
    }
    &-page {
      margin-bottom: 104px;
    }
  }
}
@media (max-width: 1000px) {
  .newsDetail {
    width: 90%;
    &-article {
      padding: 22px 0;
      &-return {
        margin-bottom: 8px;
        font-size: 14px;
        em {
          margin-right: 8px;
          font-size: 14px;
        }
      }
      &-box {
        h3 {
          margin-bottom: 28px;
          font-size: 30px;
        }
        span {
          margin-bottom: 28px;
          font-size: 14px;
          em {
            &::after {
              width: 39px;
              height: 39px;
              font-size: 23px;
            }
          }
        }
        .content {
          // padding-bottom: 100px;
        }
        &-tool {
          h4 {
            font-size: 18px;
            margin-bottom: 16px;
          }
          ul {
            margin-bottom: 24px;
            li {
              margin-right: 14px;
              font-size: 14px;
              text-align: center;
              width: 124px;
              height: 34px;
              line-height: 34px;
              border: $border-1;
            }
          }
          &-share {
            margin-top: 42px;
          }
        }
      }
      &-newsLi {
        &-text {
          span {
            font-size: 12px;
            margin-bottom: 8px;
          }
        }
      }
    }
    &-dis {
      padding: 24px 0 !important;
    }
    &-page {
      margin-bottom: 104px;
    }
  }
}
@media (max-width: 768px) {
  .imgShow {
    display: block;
  }
  .newsDetail {
    &-article {
      margin-bottom: 60px;
      &-topbg {
        display: none;
      }
      &-box {
        h3 {
          margin-bottom: 26px;
          font-size: 27px;
        }
        span {
          margin-bottom: 26px;
          font-size: 14px;
          em {
            &::after {
              width: 37px;
              height: 37px;
              font-size: 21px;
            }
          }
        }
        .content {
          /deep/ img {
            width: 100%;
            height: auto;
          }
        }
      }
      &-newsLi {
        margin-bottom: 20px;
        width: 100%;
      }
    }
    &-dis {
      flex-direction: column;
    }
  }
}
@media (max-width: 500px) {
  .canvasImg {
    width: 100%;
  }
  .popup-share-link {
    width: 300px !important;
    height: 240px !important;
    &-box {
      padding: 30px !important;
      font-size: 14px !important;
      span {
        margin-bottom: 25px !important;
      }
      input {
        height: 44px !important;
        margin-bottom: 25px !important;
      }
      .button {
        button {
          height: 36px !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/news/Detail.vue